import { useQueries } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import {
  maintenanceRequestLogsService,
  type MaintenanceRequestLogItemViewRow,
} from '@/services/maintenance';

export const useMaintenanceRequestLogItems = (maintenanceRequestIds: string[]) => {
  const queries = useQueries({
    queries: maintenanceRequestIds.map((maintenanceRequestId) => ({
      queryKey: queryKeys.maintenanceRequests.logItems(maintenanceRequestId),
      queryFn: () => maintenanceRequestLogsService.getLogItems(maintenanceRequestId),
      staleTime: 30_000,
      enabled: Boolean(maintenanceRequestId),
    })),
  });

  const itemsByLogId = new Map<string, MaintenanceRequestLogItemViewRow[]>();
  queries.forEach((query, index) => {
    const logId = maintenanceRequestIds[index];
    if (logId && query.data) {
      itemsByLogId.set(logId, query.data);
    }
  });

  const isLoading = queries.some((query) => query.isLoading);
  const isError = queries.some((query) => query.isError);

  return { itemsByLogId, isLoading, isError, queries };
};
